import React from 'react';
import { fg } from '@atlassian/jira-feature-gating';
import type PlanSettingsIssueSourcesType from '@atlassian/jira-spa-apps-advanced-roadmaps-plan/src/ui/plan-settings/issue-sources/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

/**
 * Plan Settings - issue-sources page
 */
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyPlanSettingsIssueSources = lazyForPaint<typeof PlanSettingsIssueSourcesType>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-plan-settings-plan-settings-issue-sources", jiraSpaEntry: "async-plan-settings-plan-settings-issue-sources" */ '@atlassian/jira-spa-apps-advanced-roadmaps-plan/src/ui/plan-settings/issue-sources'
			),
		),
	{ ssr: false },
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage
		Page={LazyPlanSettingsIssueSources}
		pageId="plan-settings-issue-sources"
		shouldShowSpinner={!fg('plan_settings_refresh')}
	/>
);
